import { ChangeEvent } from "react";
import styles from "./Form.module.css";

type FormType = React.FC & {
	Labels: React.FC;
	Values: React.FC;
	Field: React.FC;
	Select: React.FC<
		Omit<React.SelectHTMLAttributes<HTMLSelectElement>, "onChange"> & {
			onChange: (
				event: React.ChangeEvent<HTMLSelectElement>,
				arg: { name: string; value: string }
			) => void;
			options: Array<{
				text: string;
				value: string;
			}>;
		}
	>;
	Input: React.FC<
		Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> & {
			onChange: (
				event: React.ChangeEvent<HTMLInputElement>,
				arg: { name: string; value: string }
			) => void;
		}
	>;
	InputNumber: React.FC<{
		name: string;
		value?: number;
		onChange: (
			event: React.ChangeEvent<HTMLInputElement>,
			arg: { name: string; value: number }
		) => void;
	}>;
};

const Form: FormType = ({ children }) => <div className={styles.form}>{children}</div>;

Form.Labels = ({ children }) => <div>{children}</div>;
Form.Values = ({ children }) => <div className={styles.values}>{children}</div>;
Form.Field = ({ children }) => <div>{children}</div>;
Form.Select = ({ value = "", options = [], onChange, ...props }) => (
	<div>
		<select
			value={value}
			onChange={
				onChange && (e => onChange(e, { name: e.target.name, value: e.target.value }))
			}
			{...props}
		>
			{options.map(({ text, value }) => (
				<option key={value} value={value}>
					{text}
				</option>
			))}
		</select>
	</div>
);
Form.Input = ({ value = "", onChange, ...props }) => (
	<div>
		<input
			value={value}
			onChange={
				onChange && (e => onChange(e, { name: e.target.name, value: e.target.value }))
			}
			{...props}
		/>
	</div>
);
Form.InputNumber = ({ value = 0, onChange, ...props }) => (
	<div>
		<input
			value={value}
			onChange={(e: ChangeEvent<HTMLInputElement>) =>
				onChange &&
				onChange(e, { name: e.target.name, value: Number.parseFloat(e.target.value) })
			}
			type="number"
			step={0.01}
			min={-1}
			max={100}
			{...props}
		/>
	</div>
);

export default Form;
